var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.46999 2 1.98999 6.48 1.98999 12C1.98999 17.52 6.46999 22 11.99 22C17.51 22 21.99 17.52 21.99 12C21.99 6.48 17.51 2 11.99 2ZM15.6 8.34C16.67 8.34 17.53 9.2 17.53 10.27C17.53 11.34 16.67 12.2 15.6 12.2C14.53 12.2 13.67 11.34 13.67 10.27C13.66 9.2 14.53 8.34 15.6 8.34ZM9.59999 6.76C10.9 6.76 11.96 7.82 11.96 9.12C11.96 10.42 10.9 11.48 9.59999 11.48C8.29999 11.48 7.23999 10.42 7.23999 9.12C7.23999 7.81 8.28999 6.76 9.59999 6.76ZM9.59999 15.89V19.64C7.19999 18.89 5.29999 17.04 4.45999 14.68C5.50999 13.56 8.12999 12.99 9.59999 12.99C10.13 12.99 10.8 13.07 11.5 13.21C9.85999 14.08 9.59999 15.23 9.59999 15.89ZM11.99 20C11.72 20 11.46 19.99 11.2 19.96V15.89C11.2 14.47 14.14 13.76 15.6 13.76C16.67 13.76 18.52 14.15 19.44 14.91C18.27 17.88 15.38 20 11.99 20Z",
    fill: "#9978E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/personal.30c4115dc5b873c7c5b6fe4e10387ea9.svg";
export { ForwardRef as ReactComponent };